<template>
  <a v-if="$user.disguised" :href="this.$route('system-management.users.dropDisguise')" class="button danger text-xl mr-2" type="button">
    <i class="fas fa-mask"></i>
  </a>
</template>
